import { classEnum, type EnumType } from "./base";

export const CountersEnum = new (class extends classEnum([
    {
        label: "ADMIN",
        value: "admin",
        start: 1,
        minLength: 4,
    },
    {
        label: "ASSOCIATE",
        value: "associate",
        start: 1,
        minLength: 3,
    },
] as const satisfies EnumType<{
    start: number;
    minLength: number;
}>) {
    public minLength(name: CountersEnum.Values) {
        return this.select.find((c) => c.value === name)!.minLength;
    }
})();

export namespace CountersEnum {
    export type Labels = (typeof CountersEnum)["labels"][number];
    export type Values = (typeof CountersEnum)["values"][number];
}
